/**
 * Carina (application_id 95) のテーマカラー。
 * 未指定シェードは Tailwind の `yellow` / `amber` スケールをそのまま使う。
 */
import { tailwindScales as tw } from "../tailwindColors";
import type { ThemePalette } from "../types";

export const CARINA_PALETTE: ThemePalette = {
  appId: "95",
  appName: "Carina",
  cyan: tw.yellow,
  teal: tw.amber,
  gradient: { from: tw.yellow[500], to: tw.amber[400] },
  ink: { base: "#1C1200", soft: "#6B5200", mute: "#9A8240" },
  app: { bg: "#FFFDF4", card: "#FFFFFF" },
};
